import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { store } from "../redux/store";
import { api } from "../redux/slices/api";

const HelmetHeader = () => {
  /*   const [getConfig] = store.useLazyGetShowConfigurationQuery(); */
  const favid = useSelector((state) => state?.configurationSlice?.favId);
  const bearer = localStorage.getItem("user_token");

  const dispatch = useDispatch();
  /*   useEffect(() => {
    getConfig();
  }, []); */
  const test = window.TITLE;
  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{test}</title>
        <link
          rel="apple-touch-icon"
          sizes="57x57"
          href="/apple-icon-57x57.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="60x60"
          href="/apple-icon-60x60.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="72x72"
          href="/apple-icon-72x72.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="76x76"
          href="/apple-icon-76x76.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="114x114"
          href="/apple-icon-114x114.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="120x120"
          href="/apple-icon-120x120.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="/apple-icon-144x144.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="152x152"
          href="/apple-icon-152x152.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-icon-180x180.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="192x192"
          href="/android-icon-192x192.png"
        />
        {favid && (
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href={`${window.BASE_URL}/api/v1/image/${favid}?token=${bearer}`}
          />
        )}
        {favid && (
          <link
            rel="icon"
            type="image/png"
            sizes="96x96"
            href={`${window.BASE_URL}/api/v1/image/${favid}?token=${bearer}`}
          />
        )}
        {favid && (
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href={`${window.BASE_URL}/api/v1/image/${favid}?token=${bearer}`}
          />
        )}
        <link rel="manifest" href="/manifest.json"></link>
        <meta name="msapplication-TileColor" content="#ffffff" />
        <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="description" content="Altior water resource manager" />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        <script
          src="https://unpkg.com/react/umd/react.production.min.js"
          crossorigin
        ></script>

        <script
          src="https://unpkg.com/react-dom/umd/react-dom.production.min.js"
          crossorigin
        ></script>

        {/*      <script
          src="https://unpkg.com/react-bootstrap@next/dist/react-bootstrap.min.js"
          crossorigin
        ></script> */}
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto"
        />
        <script>var Alert = ReactBootstrap.Alert;</script>
        {/*   <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.7.1/dist/leaflet.css"
          integrity="sha512-xodZBNTC5n17Xt2atTPuE1HxjVMSvLVW9ocqUKLsCC5CXdbqCmblAshOMAS6/keqq/sMZMZ19scR4PsZChSR7A=="
          crossorigin=""
        /> */}
        <script
          src="https://unpkg.com/leaflet@1.7.1/dist/leaflet.js"
          integrity="sha512-XQoYMqMTK8LvdxXYG3nZ448hOEQiglfqkJs1NOQV44cWnUrBc8PkAOcXy20w0vlaXaVUearIOBhiXZ5V3ynxwA=="
          crossorigin=""
        ></script>
      </Helmet>
    </div>
  );
};
export default HelmetHeader;
